import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import ChangePassword from 'src/components/User/ChangePassword';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout(props) {
  const [open, setOpen] = useState(false);
 // console.log('sad', props);
  return (
    <StyledRoot>
      {props.firstPasswordChanged ? <Header onOpenNav={() => setOpen(true)} /> : null}
      {props.firstPasswordChanged ? (
        <Nav userRole={props.userRole} openNav={open} onCloseNav={() => setOpen(false)} />
      ) : null}

      <Main>
        {props.firstPasswordChanged ? null : <ChangePassword />}
        {props.firstPasswordChanged ? <Outlet /> : null}
      </Main>
    </StyledRoot>
  );
}
